module.exports = __webpack_public_path__ + "static/images/lottery-main-bg.49e3001.png";